var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-teacher-rd-salary-audit",
    },
    [
      _c("div", { staticClass: "yxtbiz-teacher-rd-salary-audit__title" }, [
        _vm._v(_vm._s(_vm.$t("pc_biz_te_lbl_billing_info" /* 结算信息 */))),
      ]),
      _c(
        "div",
        { staticClass: "mt24" },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-teacher-rd-salary-audit__info-wrapper" },
            _vm._l(_vm.auditLists, function (info) {
              return _c(
                "div",
                {
                  key: info.name,
                  staticClass:
                    "w-50p yxtbiz-teacher-rd-salary-audit__info-line",
                },
                [
                  _c("span", { staticClass: "color-gray-7 d-in-block lh22" }, [
                    _vm._v(_vm._s(info.name)),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": "", placement: "top" } },
                    [
                      _c("yxtbiz-user-name", {
                        attrs: { slot: "content", name: info.value || "--" },
                        slot: "content",
                      }),
                      _c("yxtbiz-user-name", {
                        staticClass:
                          "color-gray-10 d-in-block lh22 ellipsis w-max-70p nowrap",
                        attrs: { name: info.value || "--" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "yxt-button",
            {
              staticClass: "mt24",
              attrs: { type: "text", disabled: !_vm.formId },
              on: { click: _vm.viewDetail },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "pc_biz_te_view_salarydetail" /* 查看薪酬结算单详情 */
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }